<template>
  <div>
    <div class="events-header">
      <h3>{{ header }}</h3>
      <divider />
    </div>
    <div class="events-drawer">
      <div>
        <div v-if="events.length > 0" class="events-list">
          <div v-for="(event, index) in events" :key="index" class="event-item">
            <div class="left-section">
              <h4 class="header">{{ event.title }}</h4>
              <p class="sub-header">{{ event.details }}</p>
              <p class="details">{{ event.content }}</p>
            </div>
            <a
              v-if="event.link"
              :href="event.link"
              target="_blank"
              class="button"
            >
              Learn More
              <i class="fa-solid fa-arrow-right"></i>
            </a>
          </div>
        </div>
        <div v-else class="no-events">No upcoming events at this time.</div>
      </div>
    </div>
  </div>
</template>

<script>
import Divider from "../default/Divider.vue";

export default {
  name: "EventsDrawer",
  components: {
    Divider,
  },
  props: {
    header: {
      type: String,
      default: "",
    },
    events: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.events-header {
  text-align: center;
  padding: 1em;
}
.events-drawer {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 1em;
}
.events-list {
  display: flex;
  flex-direction: column;
  gap: 1em;
  align-items: stretch;
}
.left-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.event-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: 2px solid var(--secondary-gray);
  border-radius: 8px;
  padding: 1em;
  background-color: #f0f0f0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.event-item:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transform: translateY(-4px);
  transition: all 0.3s ease;
}
.header {
  padding: 0;
}
.sub-header {
  margin: 0;
  font-size: 1.25em;
}
.details {
  font-size: 1em;
  margin-bottom: 0;
  max-width: 700px;
}
.no-events {
  text-align: center;
  font-size: 1.25em;
}
.button {
  align-self: center;
  padding: 0.5em 1em;
  background-color: transparent;
  color: var(--secondary-blue);
  border: 2px solid var(--secondary-blue);
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
}
.button:hover {
  background-color: var(--secondary-blue);
  color: white;
}
@media (max-width: 1225px) {
  .details {
    max-width: 600px;
  }
}
@media (max-width: 1097px) {
  .details {
    max-width: 500px;
  }
}
@media (max-width: 875px) {
  .details {
    max-width: 400px;
  }
}
/* 755px */
@media (max-width: 755px) {
  .details {
    max-width: 300px;
  }
}
@media (max-width: 669px) {
  .details {
    max-width: 299px;
  }
}
@media (max-width: 630px) {
  h4 {
    font-size: 1.25em;
  }
  .sub-header {
    font-size: 1.1em;
  }
  .details {
    max-width: 200px;
    font-size: 0.75em;
  }
  .button {
    padding: 0.25em 0.5em;
    font-size: 0.75em;
  }
  .events-drawer {
    padding: 0;
  }
}
@media (max-width: 480px) {
  h4 {
    font-size: 1.1em;
  }
  .sub-header {
    font-size: 0.75em;
  }
}
@media (max-width: 410px) {
  h4 {
    font-size: 1em;
  }
}
@media (max-width: 375px) {
  h4 {
    font-size: 0.9em;
  }
  .details {
    max-width: 150px;
    font-size: 0.65em;
  }
}
@media (max-width: 320px) {
  .event-item {
    padding: 0.5em;
  }
  h4 {
    font-size: 0.8em;
  }
  .sub-header {
    font-size: 0.65em;
  }
  .details {
    max-width: 120px;
    font-size: 0.6em;
  }
}
</style>
